module.exports = __webpack_public_path__ + "img/n4.d4f70c64.png";